import React, { useState } from 'react';
import styled from 'styled-components';
import { IMediaItem, MediaType } from 'modules/media/interfaces/api';
import { Box, Colors, Ic3Dots, IcMenuSetting, IcTrash, Text } from 'basic-ui-lib';
import IcFolder from 'modules/media/assets/icons/IcFolder';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
import thumbnailPlaceholder from 'assets/playlist-default.png';
import { useNavigate } from 'react-router-dom';
import MenuActionMobile from 'basic-ui-lib/components/MenuActionMobile';
import { ItemMenuProps } from 'basic-ui-lib/components/MenuActionMobile/ItemMenu';
import { useDeleteMediaItem } from 'modules/media/services/hooks/useDeleteMediaItem';

interface MediaManagerListModeMobileProps {
  items: IMediaItem[];
  onOpenFolder: (folder: IMediaItem) => void;
  currentPath: string;
  onSuccess: (currentPath: string) => void;
}

const MediaManagerListModeMobile = ({ items, onOpenFolder, currentPath, onSuccess }: MediaManagerListModeMobileProps) => {
  const modalConfirmRef = useModalConfirmRef();
  const navigate = useNavigate();
  const [selectedMedia, setSelectedMedia] = useState<IMediaItem | null>(null);
  const [open, setOpen] = useState(false);
  const { deleteItem } = useDeleteMediaItem({ currentPath, onSuccess });

  const mediaItems = items.filter((i) => i.type !== 'FOLDER');

  const handlePreview = (id: string) => {
    const index = mediaItems.findIndex((i) => i.id === id);
    if (index === -1) return;

    navigate('/media-detail', {
      state: {
        index,
      },
    });
  };

  const handleDelete = (item: IMediaItem) => {
    modalConfirmRef.current?.open(() => deleteItem(item), {
      message: `Do you want to delete this ${item.type.toLowerCase()}?`,
    });
  };

  // const handleEditName = async (id: string, newName: string) => {
  //   await mediaApis.renameMediaItem(id, newName);
  //   toast.success('Name updated successfully');
  //   mutate(currentPath);
  // };

  const onClickItem = (record: IMediaItem) => {
    if (record.type === MediaType.FOLDER) {
      onOpenFolder(record);
    }
    else {
      handlePreview(record.id);
    }
  };
  
    const listMenu = [
    {
      key: 'set-to-screen',
      title: 'Set to Screen',
      icon: <IcMenuSetting width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'delete',
      title: 'Delete',
      icon: <IcTrash width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
  ];

  const handleSelectMedia = (item: IMediaItem) => {
    setSelectedMedia(item);
    setOpen(true);
  };

  const handleSetToScreen = (item: IMediaItem | null) => {
    if (!item) return;
    navigate('/set-to-screen', {
      state: {
        mediaId: item.id,
      },
    });
  };

  const handleMenuClick = (item: ItemMenuProps) => {
    switch (item.key) {
      case 'set-to-screen':
        handleSetToScreen(selectedMedia);
        break;
      case 'delete':
        handleDelete(selectedMedia as IMediaItem);
        break;
      default:
        break;
    }
  };
  return (
    <Container>
      {items.map((item) => (
        <MediaListItem key={item.id} item={item} onClick={() => onClickItem(item)} onClickMore={() => handleSelectMedia(item)} />
      ))}
      <ModalConfirm ref={modalConfirmRef} />
      {/* <EditNameModal ref={editNameModalRef} /> */}
      <MenuActionMobile listMenu={listMenu} open={open} onClose={() => setOpen(false)} onClickMenu={handleMenuClick} />
    </Container>
  );
};

export default MediaManagerListModeMobile;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface MediaListItemProps {
  item: IMediaItem;
  onClick?: () => void;
  onClickMore?: () => void;
}
const MediaListItem = ({ item, onClick, onClickMore }: MediaListItemProps) => {
  return (
    <MediaListItemContainer onClick={onClick}>
      <Box display='flex' justifyContent='flex-start' alignItems='center' gap={8}>
        {item.type === MediaType.FOLDER ? (
          <IcFolder width={36} height={36} />
        ) : (
          <img src={item.thumbnail || thumbnailPlaceholder} alt={item.name} className='image-thumnail' />
        )}
        <Text body_1 medium color='primary.6' ellipsis lineClamp={1} userSelect='none'>
          {item.name}
        </Text>
      </Box>
      <button onClick={(e) => { 
          e.stopPropagation(); 
          onClickMore && onClickMore(); 
      }}>
        <Ic3Dots width={20} height={20} />
      </button>
    </MediaListItemContainer>
  );
};

const MediaListItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid ${Colors.neutral.border[1]};
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  padding: 12px 16px;
  .image-thumnail {
    width: 64px;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 4px;
  }
`;
